import { gql } from '@apollo/client';

export const fetchSubscriptionsForPaymentMethod = gql`
  query fetchSubscriptionsForPaymentMethod(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    invoiceGroupsForPaymentMethod(id: $id) {
      id
      paymentMethodBillingGroupIds
      productSubscriptions(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          billingGroupId
          billingFrequency
          billingStatus
          entitlementNumber
          id
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          edition
          cloudSiteHostname
          billedUsers
          trial
          isSandbox
          isApp
        }
      }
    }
  }
`;
